import {
  Box,
  CircularProgress,
  Modal,
  Typography,
  IconButton,
  Grid,
  Card,
  Avatar,
  Divider,
  Button,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab
} from "@mui/material";
import {
  Close,
  Person,
  Phone,
  CalendarToday,
  GetApp,
  Assignment,
  Business,
  Category,
  CurrencyRupee,
  Event,
  Groups,
  LocationCity,
  GridView,
  ViewList,
  ArrowBack
} from "@mui/icons-material";
import { CSVLink } from "react-csv";
import React, { useEffect, useState } from "react";
import { getPinReportByMemberApi } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { Routes } from "src/constant/api_url";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 1100,
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 24px 48px rgba(0,0,0,0.2)",
  p: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  maxHeight: "90vh"
};

export default function PinReportModal({
  rowData,
  open,
  onClose,
  fromProfile
}) {
  const [reportData, setReportData] = useState([]);
  const [amountData, setAmountData] = useState({
    pending_amount: 0,
    counted_amount: 0,
  });
  const [lastEligibleDate, setLastEligibleDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [tabValue, setTabValue] = useState(0);

  const isCrorepati = [2, 13].includes(Number(rowData?.p_a_p_id));

  const fetchPinReport = async () => {
    setLoading(true);
    try {
      const resp = await getPinReportByMemberApi({
        p_a_p_id: rowData.p_a_p_id,
        chpt_id: rowData.chpt_id,
        m_id: rowData.m_id
      });
      if (resp.status === 1) {
        setReportData(resp.data || []);
        setAmountData({
          pending_amount: resp.pending_amount || 0,
          counted_amount: resp.counted_amount || 0,
        });
        setLastEligibleDate(resp.last_eligible_date || "");
      } else {
        setReportData([]);
        notification({ type: "error", message: resp.message })();
      }
    } catch (error) {
      console.error("Error fetching pin report:", error);
      notification({ type: "error", message: "Failed to fetch report" })();
    } finally {
      setLoading(false);
    }
  };

  const getCardData = (item) => {
    let title = "N/A";
    let subtitle = "";
    const fields = [];
    const p_a_p_id = Number(rowData?.p_a_p_id);

    if (p_a_p_id === 1) {
      // Chapter Card
      title = item.chpt_name || "N/A";
      subtitle = item.city_name ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <LocationCity sx={{ fontSize: "0.85rem" }} /> {item.city_name}
        </Box>
      ) : "";
      if (item.metting_day) fields.push({ label: "Meeting Day", value: item.metting_day, icon: <Event sx={{ fontSize: "0.9rem" }} /> });
      if (item.launch_date) fields.push({ label: "Launch Date", value: item.launch_date, icon: <CalendarToday sx={{ fontSize: "0.9rem" }} /> });
    } else if (p_a_p_id === 6) {
      // Visitor Card
      title = item.n_m_person_name || "N/A";
      if (item.n_m_business_name) fields.push({ label: "Business", value: item.n_m_business_name, icon: <Business sx={{ fontSize: "0.9rem" }} /> });
      if (item.n_m_business_category) fields.push({ label: "Category", value: item.n_m_business_category, icon: <Category sx={{ fontSize: "0.9rem" }} /> });
      if (item.n_m_date) fields.push({ label: "Meeting Date", value: item.n_m_date, icon: <CalendarToday sx={{ fontSize: "0.9rem" }} /> });
      if (item.n_m_mo_no) fields.push({ label: "Mobile Number", value: item.n_m_mo_no, icon: <Phone sx={{ fontSize: "0.9rem" }} /> });
    } else if ([3, 4, 5, 7, 8].includes(p_a_p_id)) {
      // Member Card
      title = item.m_name || "N/A";
      if (item.mobile_no) fields.push({ label: "Mobile", value: item.mobile_no, icon: <Phone sx={{ fontSize: "0.9rem" }} /> });
      if (item.m_email_id) fields.push({ label: "Email", value: item.m_email_id, icon: <Person sx={{ fontSize: "0.9rem" }} /> });
      if (item.joining_date) fields.push({ label: "Joining Date", value: item.joining_date, icon: <CalendarToday sx={{ fontSize: "0.9rem" }} /> });
      // if (item.city_name) fields.push({ label: "City", value: item.city_name, icon: <LocationCity sx={{ fontSize: "0.85rem" }} /> });
      // if (item.chpt_name) fields.push({ label: "Chapter", value: item.chpt_name, icon: <Groups sx={{ fontSize: "0.9rem" }} /> });
      // if (item.business_name) fields.push({ label: "Business", value: item.business_name, icon: <Business sx={{ fontSize: "0.9rem" }} /> });
      // if (item.business_category) fields.push({ label: "Category", value: item.business_category, icon: <Category sx={{ fontSize: "0.9rem" }} /> });
      // if (item.m_verify_status === 1 || item.m_verify_status === 2) {
      //   fields.push({ label: "Status", value: item.m_verify_status === 1 ? "Verified" : "Verified (Premium)", icon: <Assignment sx={{ fontSize: "0.9rem" }} /> });
      // }
    } else if ([2, 13].includes(p_a_p_id)) {
      // Crorepati Card
      title = item.m_name || item.b_receiver_name || "N/A";
      // if (item.b_giver_name) fields.push({ label: "Giver", value: item.b_giver_name, icon: <Person sx={{ fontSize: "0.9rem" }} /> });
      // if (item.b_receiver_name) fields.push({ label: "Receiver", value: item.b_receiver_name, icon: <Groups sx={{ fontSize: "0.9rem" }} /> });
      if (item.b_amount) fields.push({ label: "Amount", value: `₹${Number(item.b_amount_number).toLocaleString()}`, icon: <CurrencyRupee sx={{ fontSize: "0.9rem" }} /> });
      if (item.b_date) fields.push({ label: "Date", value: item.b_date, icon: <CalendarToday sx={{ fontSize: "0.9rem" }} /> });
      // if (item.city_name) fields.push({ label: "City", value: item.city_name, icon: <LocationCity sx={{ fontSize: "0.85rem" }} /> });
      // if (item.chpt_name) fields.push({ label: "Chapter", value: item.chpt_name, icon: <Groups sx={{ fontSize: "0.9rem" }} /> });
      // if (item.business_name) fields.push({ label: "Business", value: item.business_name, icon: <Business sx={{ fontSize: "0.9rem" }} /> });
      // if (item.business_category) fields.push({ label: "Category", value: item.business_category, icon: <Category sx={{ fontSize: "0.9rem" }} /> });
    } else {
      // Fallback
      title = item.m_name || item.n_m_person_name || item.chpt_name || "N/A";
      if (item.mobile_no || item.n_m_mo_no) fields.push({ label: "Mobile", value: item.mobile_no || item.n_m_mo_no, icon: <Phone sx={{ fontSize: "0.9rem" }} /> });
      if (item.city_name) fields.push({ label: "City", value: item.city_name, icon: <LocationCity sx={{ fontSize: "0.85rem" }} /> });
    }

    const profileImage = item.photo || null;
    return { title, subtitle, fields, profileImage };
  };

  const exportRef = React.useRef();

  useEffect(() => {
    if (open && rowData.p_a_p_id && rowData.m_id) {
      fetchPinReport();
    }
  }, [open, rowData]);

  const filteredData = isCrorepati
    ? reportData.filter((item) => Number(item.is_pending) === tabValue)
    : reportData;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {/* Header */}
        <Box sx={{ p: 2.5, bgcolor: "#034766", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {fromProfile && (
              <IconButton onClick={onClose} sx={{ color: "#fff", mr: 1, p: 0 }}>
                <ArrowBack />
              </IconButton>
            )}
            <Assignment />
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
              Pin Report - {rowData?.p_name} - {rowData?.m_name}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, next) => next && setViewMode(next)}
              size="small"
              sx={{
                bgcolor: "rgba(255,255,255,0.1)",
                borderRadius: "8px",
                "& .MuiToggleButton-root": {
                  color: "#fff",
                  border: "none",
                  px: 1.5,
                  "&.Mui-selected": {
                    bgcolor: "#fff",
                    color: "#034766",
                    "&:hover": { bgcolor: "#fff" }
                  }
                }
              }}
            >
              <ToggleButton value="grid">
                <GridView sx={{ fontSize: "1.2rem" }} />
              </ToggleButton>
              <ToggleButton value="list">
                <ViewList sx={{ fontSize: "1.2rem" }} />
              </ToggleButton>
            </ToggleButtonGroup>
            <IconButton onClick={onClose} sx={{ color: "#fff" }}>
              <Close />
            </IconButton>
          </Box>
        </Box>

        {/* Tabs for Crorepati */}
        {isCrorepati && (
          <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#fff" }}>
            <Tabs
              value={tabValue}
              onChange={(e, newValue) => setTabValue(newValue)}
              sx={{
                px: 2,
                "& .MuiTabs-indicator": {
                  backgroundColor: "#034766",
                  height: 3,
                  borderRadius: "3px 3px 0 0"
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  minWidth: 120,
                  color: "#64748B",
                  "&.Mui-selected": {
                    color: "#034766"
                  }
                }
              }}
            >
              <Tab label={`Counted (${amountData.counted_amount})`} />
              <Tab label={`Pending (${amountData.pending_amount})`} />
            </Tabs>
          </Box>
        )}

        {/* Content */}
        <Box sx={{ p: 4, overflowY: "auto", flexGrow: 1, bgcolor: "#F1F5F9" }}>
          {lastEligibleDate && (
            <Box sx={{ mb: 2, p: 2, bgcolor: "#FFF3CD", borderRadius: "8px", border: "1px solid #FFEAA7" }}>
              <Typography sx={{ color: "#856404", fontSize: "0.9rem", fontWeight: 500 }}>
                {lastEligibleDate}
              </Typography>
            </Box>
          )}
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" py={10}>
              <CircularProgress sx={{ color: "#034766" }} />
            </Box>
          ) : filteredData.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 10 }}>
              <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                No report data found for this member.
              </Typography>
            </Box>
          ) : viewMode === "grid" ? (
            <Grid container spacing={2}>
              {filteredData.map((item, index) => {
                const { title, subtitle, fields, profileImage } = getCardData(item);
                return (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card sx={{
                      p: 2.5,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "16px",
                      border: "1px solid #E2E8F0",
                      boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)",
                      bgcolor: "#fff",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)"
                      }
                    }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                        {profileImage ? (
                          <Box sx={{ position: "relative", display: "inline-block" }}>
                            <Avatar src={`${Routes.API_HOSTNAME}images/member/${profileImage}`} sx={{ width: 44, height: 44, border: "2px solid #E2E8F0" }} />
                            {(item?.m_verify_status === 1 || item?.m_verify_status === 2) && (
                              <Box
                                component="img"
                                src={item?.m_verify_status === 1 ? "/static/icons/verified.png" : "/static/icons/verified_blue.png"}
                                alt="Verified"
                                sx={{
                                  width: 20,
                                  height: 20,
                                  position: "absolute",
                                  top: 5,
                                  right: 3,
                                  transform: "translate(30%, -30%)"
                                }}
                              />
                            )}
                          </Box>
                        ) : <Box />}
                        <Typography sx={{ color: "#64748B", fontSize: "0.8rem", fontWeight: 600 }}>
                          Sr No. {index + 1}
                        </Typography>
                      </Box>

                      <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", color: "#1E293B", lineBreak: "anywhere" }}>
                        {title}
                      </Typography>
                      <Typography sx={{ color: "#64748B", fontSize: "0.85rem", mb: 2, fontWeight: 500 }}>
                        {subtitle}
                      </Typography>

                      <Divider sx={{ mb: 2, borderColor: "#F1F5F9" }} />

                      <Stack spacing={1.5} sx={{ mt: "auto" }}>
                        {fields.map((field, idx) => (
                          <Box key={idx} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              {React.cloneElement(field.icon, { sx: { ...field.icon.props.sx, color: "#94A3B8" } })}
                              <Typography sx={{ color: "#64748B", fontSize: "0.85rem", fontWeight: 500 }}>{field.label}</Typography>
                            </Box>
                            <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#334155", textAlign: "right" }}>{field.value}</Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "12px", border: "1px solid #E2E8F0" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: "#F8FAFC", fontWeight: 700, width: "80px" }}>Sr No</TableCell>
                    <TableCell sx={{ bgcolor: "#F8FAFC", fontWeight: 700 }}>Details</TableCell>
                    <TableCell sx={{ bgcolor: "#F8FAFC", fontWeight: 700 }}>More Information</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.map((item, index) => {
                    const { title, subtitle, fields } = getCardData(item);
                    return (
                      <TableRow key={index} hover>
                        <TableCell width={60}>{index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{title}</Typography>
                          <Typography variant="caption" color="text.secondary">{subtitle}</Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            {fields.map((field, idx) => (
                              <Box key={idx} sx={{ display: "flex", alignItems: "center" }}>
                                <span style={{ opacity: 0.6, marginRight: 8 }}>
                                  {field.icon}
                                </span>

                                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                  {field.label}:
                                </Typography>

                                <Typography variant="caption" sx={{ ml: 1 }}>
                                  {field.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{ p: 2.5, display: "flex", justifyContent: "flex-end", gap: 2, borderTop: "1px solid #E2E8F0", bgcolor: "#fff" }}>
          <Button onClick={onClose} sx={{ color: "#64748B", textTransform: "none", fontWeight: 600, "&:hover": { bgcolor: "#F1F5F9" } }}>
            Cancel
          </Button>
          <CSVLink
            data={filteredData}
            filename={`Pin_Report_${rowData?.m_name}.csv`}
            className="btn btn-primary"
            ref={exportRef}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              startIcon={<GetApp />}
              sx={{
                bgcolor: "#034766",
                "&:hover": { bgcolor: "#02364d" },
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                borderRadius: "8px",
                boxShadow: "0 4px 6px -1px rgba(3,71,102,0.3)"
              }}
            >
              Export Report
            </Button>
          </CSVLink>
        </Box>
      </Box>
    </Modal>
  );
}
